import React from 'react';
import { PAYMENT_METHOD_OPTIONS, INSTALLMENT_STATUS } from '../../../core/constants/financial';
import { todayISO } from '../../../core/utils/financialPeriod';
import { formatCurrencyBRL } from '../../../core/utils/string';

const InstallmentTable = ({ installments, bankOptions, onUpdate, lockedIds }) => {
  const handleChange = ({ index, field, value }) => {
    const row = { ...installments[index], [field]: value };
    if (field === 'status') {
      if (value === INSTALLMENT_STATUS.PAGO && !row.payment_date) {
        row.payment_date = todayISO();
      }
      if (value === INSTALLMENT_STATUS.PENDENTE) {
        row.payment_date = '';
      }
    }
    const updated = [...installments];
    updated[index] = row;
    onUpdate(updated);
  };

  // Parcela já marcada como PAGA em DB (carregada no modo edição). Todos os
  // campos podem ser corrigidos e a SITUAÇÃO pode voltar para PENDENTE
  // (estorno — RN06/RN07). A reversão é aplicada no save (revertInstallmentToPending),
  // desfazendo o efeito no saldo. lockedIds/isPaidLocked mantidos por
  // compatibilidade, mas não travam mais a situação.
  const isPaidLocked = (inst) => !!(inst.id && lockedIds && lockedIds.has(inst.id));

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="fd-modal-table" style={{ fontSize: 11 }}>
        <thead>
          <tr>
            <th style={{ width: 30 }}>#</th>
            <th style={{ width: 130 }}>Vencimento</th>
            <th style={{ width: 110 }}>Valor</th>
            <th style={{ width: 120 }}>Forma Pgto</th>
            <th style={{ width: 120 }}>Banco</th>
            <th style={{ width: 80, textAlign: 'center' }}>Situação</th>
            <th style={{ width: 130 }}>Data Pagamento</th>
          </tr>
        </thead>
        <tbody>
          {installments.map((inst, i) => {
            // Só a Situação trava em parcelas já pagas em DB. Os demais campos
            // ficam editáveis (a correção reconcilia o saldo no save).
            const wasPaid = isPaidLocked(inst);
            const statusTitle = wasPaid
              ? 'Parcela paga — selecione Pendente para estornar (aplicado ao salvar).'
              : undefined;
            return (
              <tr key={inst.id ?? i} style={{ background: i % 2 === 1 ? 'rgba(255,255,255,0.02)' : 'transparent' }}>
                <td className="fd-table-muted" style={{ fontSize: 10 }}>{i + 1}/{installments.length}</td>
                <td>
                  <input
                    type="date"
                    className="fd-installment-input"
                    value={inst.due_date || ''}
                    onChange={(e) => handleChange({ index: i, field: 'due_date', value: e.target.value })}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    inputMode="numeric"
                    className="fd-installment-input"
                    placeholder="R$ 0,00"
                    value={inst.value || ''}
                    onChange={(e) => handleChange({ index: i, field: 'value', value: formatCurrencyBRL(e.target.value) })}
                    style={{ width: 90 }}
                  />
                </td>
                <td>
                  <select
                    className="fd-installment-input"
                    value={inst.payment_method || ''}
                    onChange={(e) => handleChange({ index: i, field: 'payment_method', value: e.target.value })}
                  >
                    <option value="">—</option>
                    {PAYMENT_METHOD_OPTIONS.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="fd-installment-input"
                    value={inst.bank_id || ''}
                    onChange={(e) => handleChange({ index: i, field: 'bank_id', value: e.target.value ? Number(e.target.value) : null })}
                  >
                    <option value="">—</option>
                    {bankOptions.map((b) => (
                      <option key={b.value} value={b.value}>{b.label}</option>
                    ))}
                  </select>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <select
                    className="fd-installment-input"
                    value={inst.status || INSTALLMENT_STATUS.PENDENTE}
                    title={statusTitle}
                    style={{
                      color:
                        inst.status === INSTALLMENT_STATUS.PAGO
                          ? '#70E000'
                          : '#e88c2a',
                      fontWeight: 700,
                    }}
                    onChange={(e) =>
                      handleChange({ index: i, field: 'status', value: e.target.value })
                    }
                  >
                    <option value={INSTALLMENT_STATUS.PENDENTE}>Pendente</option>
                    <option value={INSTALLMENT_STATUS.PAGO}>Pago</option>
                  </select>
                </td>
                <td>
                  {inst.status === INSTALLMENT_STATUS.PAGO ? (
                    <input
                      type="date"
                      className="fd-installment-input"
                      value={inst.payment_date || ''}
                      onChange={(e) => handleChange({ index: i, field: 'payment_date', value: e.target.value })}
                    />
                  ) : (
                    <span className="fd-table-muted">—</span>
                  )}
                </td>
              </tr>
            );
          })}
          {installments.length === 0 && (
            <tr>
              <td colSpan={7} className="fd-table-empty">Clique em GERAR para criar as parcelas</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InstallmentTable;
